import { useQuery } from "@tanstack/react-query";
import { spySerpService } from "@/services/SpySerpService";

export const SPYSERP_FILTER_OPTIONS_QUERY_KEY = [
  "spyserp",
  "filterOptions",
] as const;

export const useSpyserpFilterOptions = () =>
  useQuery({
    queryKey: SPYSERP_FILTER_OPTIONS_QUERY_KEY,
    queryFn: () => spySerpService.getFilterOptions(),
    staleTime: 1000 * 60 * 5,
  });
